import { Flower2 } from "lucide-react";

const ITEMS = [
  "Aroma Therapy",
  "Balinese Massage",
  "Deep Tissue",
  "Thai Massage",
  "Four Hand Massage",
  "Full Body Massage",
  "Jacuzzi Spa",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee relative overflow-hidden border-y border-gold/15 bg-ember/60 py-5"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif-display text-2xl italic text-stone-400 sm:text-3xl">
                  {item}
                </span>
                <Flower2 size={16} className="shrink-0 text-gold/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
